import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn:"root"
})
export class SvgService {
  private path: string = 'assets/img/svg';

  constructor(private http: HttpClient) {  }

  loadSvg(name: string): Observable<string> {
    return this.http.get(`${this.path}/${name}.svg`, {responseType: 'text'});
  }
}
